import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading Re-Admit Form...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-column p-4"
}
const _hoisted_6 = { class: "container row col-12 m-0 p-1" }
const _hoisted_7 = { class: "col-6 form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "schedule-date" }, [
  /*#__PURE__*/_createTextVNode(" Re-Admission Date(Start of Care) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_9 = { class: "input-group flex-nowrap" }
const _hoisted_10 = { class: "input-group date datepickerInput" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "col-6 form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "admission hour" }, " Admission Hour ", -1 /* HOISTED */)
const _hoisted_16 = { class: "input-group flex-nowrap" }
const _hoisted_17 = {
  key: 0,
  class: "container row col-12 m-0 p-1"
}
const _hoisted_18 = { class: "col-6 form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "case-manager" }, [
  /*#__PURE__*/_createTextVNode(" Case Manager "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_20 = { class: "input-group d-flex flex-col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Case Manager", -1 /* HOISTED */)
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_24 = { class: "col-6 form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "assign-to-clinician" }, [
  /*#__PURE__*/_createTextVNode(" Assign to Clinician "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_26 = { class: "input-group d-flex flex-col" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Clinician", -1 /* HOISTED */)
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_30 = { class: "container row col-12 m-0 p-1" }
const _hoisted_31 = { class: "col-6 form-group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "physician" }, "Physician ", -1 /* HOISTED */)
const _hoisted_33 = { class: "input-group flex-nowrap" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Physician", -1 /* HOISTED */)
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "col-6 form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "referral-date" }, [
  /*#__PURE__*/_createTextVNode(" Referral Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_38 = { class: "input-group flex-nowrap" }
const _hoisted_39 = { class: "input-group date datepickerInput" }
const _hoisted_40 = ["value"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_42 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_43 = { class: "d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_FormSection, {
      title: `Re-Admission Information`,
      "full-height": false,
      application: _ctx.application
    }, {
      content: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
          : _createCommentVNode("v-if", true),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("input", {
                            type: "text",
                            name: "reAdmissionDate",
                            class: "form-control rounded-0 border-end-0",
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDate(_ctx.reAdmit.ReAdmissionDate),
                            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.reAdmit.ReAdmissionDate.$touch && _ctx.v$.reAdmit.ReAdmissionDate.$touch(...args)))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11),
                          _hoisted_12,
                          (_ctx.v$.reAdmit.ReAdmissionDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Re-Admission Date is required."))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_TimePicker, {
                      id: "travel-start-time",
                      onUpdateProps: _ctx.changeTime
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "hh:mm AM",
                          class: _normalizeClass(`form-control`),
                          type: "text",
                          autocomplete: "off",
                          maxlength: "8",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reAdmit.ReAdmissionHour) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, _ctx.reAdmit.ReAdmissionHour]
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onUpdateProps"])
                  ])
                ])
              ]),
              (!_ctx.isNonMedical)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("select", {
                          id: "case-manager",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reAdmit.CaseManagerId) = $event)),
                          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.reAdmit.caseManagerId.$touch && _ctx.v$.reAdmit.caseManagerId.$touch(...args)))
                        }, [
                          _hoisted_21,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caseManagersList, (caseManager) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: caseManager.Id,
                              key: `${caseManager.Id}-${caseManager.FirstName}`
                            }, _toDisplayString(caseManager.DisplayName), 9 /* TEXT, PROPS */, _hoisted_22))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [_vModelSelect, _ctx.reAdmit.CaseManagerId]
                        ]),
                        (_ctx.v$.reAdmit.CaseManagerId.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Case Manager is required."))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("select", {
                          id: "assign-to-clinician",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reAdmit.ClinicianId) = $event)),
                          onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.reAdmit.ClinicianId.$touch && _ctx.v$.reAdmit.ClinicianId.$touch(...args)))
                        }, [
                          _hoisted_27,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clinicians, (clinician) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: `${clinician.Id}-${clinician.FirstName}`,
                              value: clinician.Id
                            }, _toDisplayString(clinician.DisplayName), 9 /* TEXT, PROPS */, _hoisted_28))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [_vModelSelect, _ctx.reAdmit.ClinicianId]
                        ]),
                        (_ctx.v$.reAdmit.ClinicianId.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Clinician is required."))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("select", {
                      id: "physician",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reAdmit.PhysicianId) = $event))
                    }, [
                      _hoisted_34,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.physicianList, (physician) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `${physician.Id}-${physician.FirstName}`,
                          value: physician.Id
                        }, _toDisplayString(physician.DisplayName), 9 /* TEXT, PROPS */, _hoisted_35))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.reAdmit.PhysicianId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("input", {
                            type: "text",
                            name: "referralDate",
                            class: "form-control rounded-0 border-end-0",
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDate(_ctx.reAdmit.ReferralDate),
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                            onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.reAdmit.ReferralDate.$touch && _ctx.v$.reAdmit.ReferralDate.$touch(...args)))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_40),
                          _hoisted_41,
                          (_ctx.v$.reAdmit.ReferralDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Referral Date is required."))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reAdmitPatient()))
                }, "Re-Admit"),
                _createElementVNode("button", {
                  type: "button",
                  class: "ms-1 btn btn-md btn-outline-secondary",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCloseForm()))
                }, " Close ")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application"])
  ]))
}